import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "pop_up com_pop",
  style: {"display":"block"}
}
const _hoisted_2 = { class: "pop_tit _flex" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "sign_form custom_scroll" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 1,
  class: "p_info"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "p_info"
}
const _hoisted_10 = {
  key: 0,
  class: "p_warn"
}
const _hoisted_11 = ["for"]
const _hoisted_12 = ["id", "value"]
const _hoisted_13 = { class: "_flex _center btn_wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "pop_up_layer com_pop",
      style: {"display":"block"},
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        ($setup.state.mode)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, "관리자 추가"))
          : (_openBlock(), _createElementBlock("p", _hoisted_4, "관리자 수정")),
        _createElementVNode("button", {
          class: "close_btn icon_wrap",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
        }, [...(_cache[13] || (_cache[13] = [
          _createElementVNode("img", {
            src: "img/close.png",
            alt: "닫기"
          }, null, -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", {
            class: _normalizeClass({ imp: $setup.state.mode })
          }, [
            _cache[14] || (_cache[14] = _createElementVNode("label", {
              for: "user_id",
              class: "form_li_tit"
            }, "아이디", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "user_id",
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form_state.id) = $event)),
              onChange: _cache[3] || (_cache[3] = ($event: any) => ($setup.state.idExistCheck = false)),
              class: _normalizeClass({ blocked: !$setup.state.mode }),
              disabled: !$setup.state.mode
            }, null, 42, _hoisted_6), [
              [_vModelText, $setup.form_state.id]
            ]),
            ($setup.state.mode)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "blue_btn",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.idExist && $setup.idExist(...args)))
                }, "중복확인"))
              : _createCommentVNode("", true),
            (!$setup.state.idIsPossible && $setup.state.mode)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, "영문자, 숫자, _만 입력 가능/ 최소 6자 이상 12자 이하로 입력하세요."))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass({ imp: $setup.state.mode })
          }, [
            _cache[15] || (_cache[15] = _createElementVNode("label", {
              for: "",
              class: "form_li_tit"
            }, "이름", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "이름을 입력하세요",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form_state.name) = $event)),
              class: _normalizeClass({ blocked: !$setup.state.mode }),
              disabled: !$setup.state.mode
            }, null, 10, _hoisted_8), [
              [_vModelText, $setup.form_state.name]
            ])
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass({ imp: $setup.state.mode })
          }, [
            _cache[16] || (_cache[16] = _createElementVNode("label", {
              for: "user_pw",
              class: "form_li_tit"
            }, "비밀번호", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "user_pw",
              type: "password",
              placeholder: "비밀번호를 입력하세요",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form_state.pw) = $event))
            }, null, 512), [
              [_vModelText, $setup.form_state.pw]
            ]),
            (!$setup.state.pwIsPossible)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, "비밀번호는 문자, 숫자, 특수문자의 조합으로 8자 이상 입력해주세요."))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass({ imp: $setup.state.mode })
          }, [
            _cache[17] || (_cache[17] = _createElementVNode("label", {
              for: "user_pw_chk",
              class: "form_li_tit"
            }, "비밀번호 확인", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "user_pw_chk",
              type: "password",
              placeholder: "비밀번호 확인",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.form_state.pwConfirm) = $event))
            }, null, 512), [
              [_vModelText, $setup.form_state.pwConfirm]
            ]),
            ($setup.state.pwIsPossible && $setup.form_state.pw !== $setup.form_state.pwConfirm)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, " *비밀번호가 일치하지 않습니다. 다시 입력해주세요. "))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass(["join_way_wrap checkbox_wrap", { imp: $setup.state.mode }])
          }, [
            _cache[19] || (_cache[19] = _createElementVNode("span", { class: "form_li_tit" }, "담당사업", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.roleList, (item, index) => {
              return (_openBlock(), _createElementBlock("label", {
                key: item.roIdx,
                for: 'join_way' + item.roIdx,
                class: _normalizeClass(item.roIdx === 5 ? 'need_space' : '')
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: 'join_way' + item.roIdx,
                  name: "join_way",
                  value: item.roIdx,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.state.selectedRole) = $event))
                }, null, 8, _hoisted_12), [
                  [_vModelCheckbox, $setup.state.selectedRole]
                ]),
                _cache[18] || (_cache[18] = _createElementVNode("em", null, null, -1)),
                _createElementVNode("span", null, _toDisplayString(item.roName), 1)
              ], 10, _hoisted_11))
            }), 128))
          ], 2)
        ]),
        _cache[20] || (_cache[20] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            class: "submit_btn _130 _gray",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
          }, "취소"),
          (!($setup.form_state.idx && $setup.form_state.idx > 0))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "submit_btn _130 _main_blue",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => ($setup.add && $setup.add(...args)))
              }, "추가"))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "submit_btn _130 _main_blue",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => ($setup.modify && $setup.modify(...args)))
              }, "수정"))
        ])
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: _cache[12] || (_cache[12] = ($event: any) => ($setup.state.isShowModal = false)),
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}